<script setup lang="ts">
import type { AdData } from '~/components/ad-page.vue';

const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});
let response: { item?: AdData };
let text: string | undefined;
let link: { cached_url: string; target: string } | undefined;
const { params } = useRoute();
const { slug } = params;
let adId = slug[0];
if (!adId) {
    if (process.env.NODE_ENV === 'production') {
        throw createError({
            statusCode: 404,
            statusMessage: 'Not Found',
        });
    } else {
        adId = props.blok.adId;
    }
}
const {
    public: { tiptappApiBaseUrl },
} = useRuntimeConfig();
try {
    response = await $fetch<{ item: AdData }>(`${tiptappApiBaseUrl}/v1/web/ad/${adId}`, {
        method: 'GET',
    });
} catch (error) {
    console.error('Error fetching ad data:', error);
    throw createError({
        statusCode: 404,
        statusMessage: 'Not Found',
    });
}
switch (response.item?.type) {
    case 'paaw':
        text = props.blok.paawText;
        link = props.blok.paawLink;
        break;
    case 'gaaw':
        text = props.blok.gaawText;
        link = props.blok.gaawLink;
        break;
    case 'tsk':
        text = props.blok.tskText;
        link = props.blok.tskLink;
        break;
    case 'b4m':
        text = props.blok.b4mText;
        link = props.blok.b4mLink;
        break;
    case 'h2t':
        text = props.blok.h2tText;
        link = props.blok.h2tLink;
        break;
    default:
        text = undefined;
        link = undefined;
}
</script>
<template>
    <AdPage
        v-if="response.item"
        v-model="response.item"
        v-model:ctaText="text"
        v-model:ctaLink="link"
    />
</template>
